import { $t } from '@/i18n';
import { isObject, isObjectLike, pickBy } from 'lodash';
import getXyHeaders from '@/utils/getXyHeaders';
import getXyManagePathPrefix from '@/utils/getXyManagePathPrefix';
import axios from './axios';
import { getRuntimeConfig } from '../collectionAPI';
import { getBaseURL, getEnvIdFromWindow, getPageIdFromWindow, getProjectIdFromWindow, } from '../utils/wujiWindow';
import { tryStringify } from '../utils/tools';
import { requestWithMiddlewares } from './middleware';
export async function requestCGI(collectionId, cgiName, requestObj, options) {
    let { projectId, envId, pageId, } = options;
    projectId = projectId ?? getProjectIdFromWindow();
    envId = envId ?? getEnvIdFromWindow();
    pageId = pageId ?? getPageIdFromWindow();
    if (!projectId)
        throw new Error('need projectId');
    const collection = await getRuntimeConfig({
        collectionId,
        envId,
        pageId,
        projectId,
    });
    if (!collection)
        throw new Error($t('k_f07e8318', { arg_0: collectionId }));
    const cgiInfo = collection.cgiInfo[cgiName];
    if (!cgiInfo)
        throw new Error(`The data source method \`${cgiName}\` does not exist.`);
    const requestConfig = getRequestConfig({
        requestObj,
        cgiName,
        cgiInfo,
        projectId,
        pageId,
        collectionId,
    });
    const ctx = {
        cgiName,
        collectionId,
        pageId,
        projectId,
        envId,
        cgiInfo,
        collection,
        requestConfig,
        request: requestObj,
    };
    return await requestWithMiddlewares(ctx, () => axios(requestConfig));
}
function getRequestConfig(options) {
    const { requestObj, cgiInfo, projectId, pageId, collectionId, cgiName, } = options;
    const { query, headers, body } = requestObj;
    const params = {};
    if (isObject(query)) {
        Object.entries(query).forEach(([key, value]) => {
            params[key] = isObjectLike(value) ? tryStringify(value) : value;
        });
    }
    const { type } = cgiInfo;
    // projectId/pageId/collectionId or projectId/collectionId
    const parts = [projectId, pageId, collectionId].filter(Boolean).join('/');
    const requestConfig = {
        baseURL: getBaseURL(),
        url: `${getXyManagePathPrefix()}/datasource/collection/request/${parts}/${cgiName}`,
        method: type,
        params,
        headers: { ...headers, ...getXyHeaders() },
        withCredentials: true,
        paramsSerializer(params) {
            const query = pickBy(params || {}, value => value !== undefined);
            return new URLSearchParams(query).toString();
        },
    };
    if (type.toLowerCase() === 'post') {
        requestConfig.data = body;
    }
    if (cgiInfo.responseType === 'blob') {
        requestConfig.responseType = 'blob';
    }
    else if (cgiInfo.responseType === 'arraybuffer') {
        requestConfig.responseType = 'arraybuffer';
    }
    return requestConfig;
}
